export const SET_USER = "SET_USER";
export const USER_LOGOUT = "USER_LOGOUT";
export const UPDATE_USER_ACCESS_TOKEN = "UPDATE_ACCESS_TOKEN";
